export const ACCESS_TOKEN_STORAGE_KEY = 'token';
export const REFRESH_TOKEN_STORAGE_KEY = 'refreshToken';

const normalizeStoredValue = (value: string | null): string | null => {
  if (!value || value === 'null' || value === 'undefined') {
    return null;
  }
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
};

export const readStoredAccessToken = (): string | null => {
  try {
    return normalizeStoredValue(localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY));
  } catch {
    return null;
  }
};

export const readStoredRefreshToken = (): string | null => {
  try {
    return normalizeStoredValue(localStorage.getItem(REFRESH_TOKEN_STORAGE_KEY));
  } catch {
    return null;
  }
};

export const storeAuthTokens = (params: {
  accessToken: string | null;
  refreshToken?: string | null;
}): void => {
  try {
    if (params.accessToken) {
      localStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, params.accessToken);
    } else {
      localStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
    }

    if (params.refreshToken !== undefined) {
      if (params.refreshToken) {
        localStorage.setItem(REFRESH_TOKEN_STORAGE_KEY, params.refreshToken);
      } else {
        localStorage.removeItem(REFRESH_TOKEN_STORAGE_KEY);
      }
    }
  } catch {
    // Ignore storage failures.
  }
};

export const clearStoredAuth = (): void => {
  try {
    localStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
    localStorage.removeItem(REFRESH_TOKEN_STORAGE_KEY);
  } catch {
    // Ignore storage failures.
  }
};
